export default __webpack_public_path__ + "static/media/dispatched_hover_noeld.cc3fedcd.svg";